import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';



import './css/style.css';
import './css/demo.css';
import './css/effect_style.css';
import './css/responsive_bootstrap_carousel.css';
// import './css/responsive-style.css';
import './css/set1.css';
import './css/slick.min.css';
import './css/bootstrap.min.css';
import './css/animate.min.css';
import './css/jquery.fancybox.css';
import './css/animate.css';


import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);


reportWebVitals();
